import React from 'react';

const Navbar = () => {
    return (
        <div
            className="absolute top-0 left-0 text-center w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg z-50"
        >
            Simple Todo Application with Redux
        </div>

    );
};

export default Navbar;